import { Dispatch, SetStateAction } from 'react';
import { SEOSegmentationFilterInput, Language } from '@/__generated__/globalTypes';
import { MultiSelectPills } from './MultiSelectPills';

interface LanguagesSpokenInterface {
  languagesSpoken: SEOSegmentationFilterInput['languages'];
  setLanguagesSpoken: Dispatch<SetStateAction<SEOSegmentationFilterInput['languages']>>;
}

const LanguagesSpoken = ({ languagesSpoken, setLanguagesSpoken }: LanguagesSpokenInterface) => {
  const languagesList = [
    { label: 'American Sign Language', value: Language.SIGN_LANGUAGE_ASL },
    { label: 'Arabic', value: Language.ARABIC },
    { label: 'Chinese (Mandarin)', value: Language.CHINESE },
    { label: 'English', value: Language.ENGLISH },
    { label: 'French', value: Language.FRENCH },
    { label: 'German', value: Language.GERMAN },
    { label: 'Hindi', value: Language.HINDI },
    { label: 'Japanese', value: Language.JAPANESE },
    { label: 'Korean', value: Language.KOREAN },
    { label: 'Portuguese', value: Language.PORTUGUESE },
    { label: 'Russian', value: Language.RUSSIAN },
    { label: 'Spanish', value: Language.SPANISH },
    { label: 'Tagalog', value: Language.TAGALOG },
  ];

  const handleOnChangeEvent = (values: Language[]) => {
    setLanguagesSpoken(values);
  };

  return (
    <MultiSelectPills
      sectionName="Languages spoken"
      handleOnChangeEvent={handleOnChangeEvent}
      pillOptions={languagesList}
      category="LANGUAGES_SPOKEN"
      selectedValues={languagesSpoken || []}
    />
  );
};

export { LanguagesSpoken };
